<template>
    <div class="pa-5">
        <v-row class="edit-row">
            <v-col class="col-item row-title mt-2" cols="3">{{ "Name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                <v-text-field
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField('ext_product.name', $event)"
                    :value="activeExtProductPrice.ext_product.name"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="edit-row">
            <v-col class="col-item row-title mt-2" cols="3">{{ "Weight" | t }}</v-col>
            <v-col class="col-item" cols="6">
                <v-text-field
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField('ext_product.weight', $event)"
                    :value="activeExtProductPrice.ext_product.weight"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="edit-row">
            <v-col class="col-item row-title mt-2" cols="3">{{ "EAN" | t }}</v-col>
            <v-col class="col-item" cols="6">
                <v-text-field
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField('ext_product_code.ean', $event)"
                    :value="activeExtProductPrice.ext_product_code.ean"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="edit-row">
            <v-col class="col-item row-title mt-2" cols="3">{{ "Related product" | t }}</v-col>
            <v-col class="col-item" cols="6">
                <v-autocomplete
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    :value="
                        activeExtProductPrice.related_product && activeExtProductPrice.related_product.id
                            ? activeExtProductPrice.related_product.id
                            : null
                    "
                    :items="products"
                    item-text="name"
                    item-value="id"
                    @input="updateField('related_product.id', $event)"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row class="edit-row">
            <v-col class="col-item row-title mt-2" cols="3">{{ "Shop" | t }}</v-col>
            <v-col class="col-item" cols="6">
                <v-autocomplete
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    :value="
                        activeExtProductPrice.shop && activeExtProductPrice.shop.id
                            ? activeExtProductPrice.shop.id
                            : null
                    "
                    :items="shops"
                    item-text="name"
                    item-value="id"
                    @input="updateField('shop.id', $event)"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row class="edit-row">
            <v-col class="col-item row-title mt-2" cols="3">{{ "Original price" | t }}</v-col>
            <v-col class="col-item" cols="6">
                <v-text-field
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField('original_price', $event)"
                    :value="activeExtProductPrice.original_price"
                    type="number"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="edit-row">
            <v-col class="col-item row-title mt-2" cols="3">{{ "Discount price" | t }}</v-col>
            <v-col class="col-item" cols="6">
                <v-text-field
                    class="text-field-item mb-1 bg-yellow"
                    dense
                    hide-details
                    outlined
                    @input="updateField('discount_price', $event)"
                    :value="activeExtProductPrice.discount_price"
                    type="number"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="edit-row">
            <v-col class="col-item row-title mt-6" cols="3">{{ "Visited at" | t }}</v-col>
            <v-col cols="6" class="col-item mt-0">
                <v-row class="mt-0">
                    <v-col cols="6">
                        <v-menu
                            ref="visitedAtDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    style="width: 100%"
                                    dense
                                    class="text-field-item mb-1"
                                    outlined
                                    :value="newVisitedAtDateValue"
                                    append-icon="fas fa-calendar"
                                    readonly
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="newVisitedAtDate"
                                mode="date"
                                first-day-of-week="1"
                                @input="$refs.visitedAtDateMenu.isActive = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="6">
                        <time-input
                            class="text-field-item mb-1"
                            dense
                            hide-details
                            outlined
                            v-model="newVisitedAtTime"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import TimeInput from "@/components/time-input.vue";
import moment from "moment/moment";
import Store from "@/store";

export default {
    name: "general-edit",
    components: { TimeInput },
    data() {
        return {
            newVisitedAtDate: null,
            newVisitedAtTime: null
        };
    },
    async mounted() {
        if (this.activeExtProductPrice.visited_at) {
            const [datePart, timePart] = this.activeExtProductPrice.visited_at.split("T");
            const [hours, minutes, seconds] = timePart.split(":");
            this.newVisitedAtDate = datePart;
            this.newVisitedAtTime = `${hours}:${minutes}`;
        } else {
            this.newVisitedAtDate = moment().format("YYYY-MM-DD");
        }
        if (this.products.length === 0 || this.shops.length === 0) {
            await this.getFrequentlyUsedQueries({ products: true, shops: true });
        }
    },
    computed: {
        ...mapState("ExtProductStore", ["activeExtProductPrice"]),
        ...mapState(["products", "shops"]),
        newVisitedAtDateValue() {
            return this.getVisitedAtDateValue();
        }
    },
    watch: {
        newVisitedAtTime() {
            this.updateField("visited_at_time", this.newVisitedAtTime);
        },
        newVisitedAtDate() {
            this.updateField("visited_at_date", this.newVisitedAtDate);
        }
    },
    methods: {
        ...mapActions(["getFrequentlyUsedQueries"]),
        ...mapMutations("ExtProductStore", ["updateActiveExtProductPriceField"]),
        updateField(field, value) {
            this.updateActiveExtProductPriceField({ field, value });
        },
        getVisitedAtDateValue() {
            if (!this.newVisitedAtDate) {
                return moment().format("DD.MM.YYYY");
            }
            return moment(this.newVisitedAtDate).format("DD.MM.YYYY");
        }
    }
};
</script>

<style scoped>
.edit-row {
    height: 4rem;
}
.row-title {
    color: gray;
}

.bg-yellow {
    background-color: #ffffbe;
}
</style>
